import React from "react";
import { AlertCircle, ShieldCheck } from "lucide-react";
import { phrasesChampsManquants } from "../../lib/champsManquants";

/**
 * Après le code (identité prouvée) : la fiche du donateur est pré-remplie
 * dans le formulaire, il peut la modifier ou la compléter — ce qu'il saisit
 * est enregistré sur SA fiche au moment du don. Ce qui manque encore (adresse
 * du reçu fiscal, téléphone…) est mis en avant.
 *
 * Props :
 *  - manquants      : ``missing_fields`` renvoyés par recognize-donor avec le jeton
 *  - onRecommencer  : autre personne / autre contact (facultatif)
 *  - textes         : libellés traduits (page de don bilingue), y compris
 *                     ceux des champs manquants (clés de PHRASES_MANQUANTS)
 */
const TEXTES = {
  titre: "Identité vérifiée",
  corps: "Vos informations sont pré-remplies : modifiez-les ou complétez-les, elles seront enregistrées sur votre fiche.",
  recommencer: "Recommencer",
};

export default function IdentiteVerifiee({ manquants, onRecommencer, textes }) {
  const t = { ...TEXTES, ...(textes || {}) };
  const aCompleter = phrasesChampsManquants(manquants, textes);
  return (
    <div className="mb-3 space-y-2" data-testid="identite-verifiee">
      <div className="rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-2.5">
        <div className="flex items-start gap-2.5">
          <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" aria-hidden="true" />
          <div className="min-w-0 flex-1">
            <div className="flex items-center justify-between gap-2">
              <p className="text-sm font-semibold text-emerald-800">{t.titre}</p>
              {onRecommencer && (
                <button type="button" onClick={onRecommencer}
                  className="trm-cible-tactile shrink-0 text-xs text-emerald-700 underline hover:text-emerald-900">
                  {t.recommencer}
                </button>
              )}
            </div>
            <p className="mt-0.5 text-xs leading-relaxed text-emerald-700">{t.corps}</p>
          </div>
        </div>
      </div>
      {aCompleter.length > 0 && (
        <div className="flex items-start gap-2 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2.5"
          role="status" data-testid="champs-manquants">
          <AlertCircle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-amber-600" aria-hidden="true" />
          <ul className="space-y-0.5 text-xs leading-relaxed text-amber-800">
            {aCompleter.map((p) => <li key={p}>{p}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
}
